import { render, staticRenderFns } from "./ResizableTextArea.vue?vue&type=template&id=4c130174&scoped=true"
import script from "./ResizableTextArea.vue?vue&type=script&lang=js"
export * from "./ResizableTextArea.vue?vue&type=script&lang=js"
import style0 from "./ResizableTextArea.vue?vue&type=style&index=0&id=4c130174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c130174",
  null
  
)

export default component.exports